import { FormGroup, FormControl } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { UnidadeFederacaoModel, MunicipioModel, MunicipioService } from '../index';

import { EnderecoModel } from '../endereco/';
import { EnderecoService } from '../endereco/endereco.service';
import { FiltroEnderecoPorLogradouroModel } from '../model/filtro-endereco-logradouro';


@Component({
  selector: 'ngbd-modal-content',
  template: `
    <form autocomplete="off" [formGroup]="dadosConsultarLogradouro">

      <div class="modal-header">
        <h4 class="modal-title">{{titulo}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="ddlUF">UF</label> *
              <select class="form-control" id="ddlUF" name="ddlUF" formControlName="ddlUF" (change)="onSelecionarUF($event.target.value)">
                <option value="" selected>Selecione</option>
                <option *ngFor="let uf of ufs" [value]="uf">{{uf}}</option>
              </select>
            </div>
          </div>
          <div class="col-8">
            <div class="form-group">
              <label for="ddlMunicipio">Município</label> *
              <select class="form-control" id="ddlMunicipio" name="ddlMunicipio" formControlName="ddlMunicipio">
                <option value="" selected>Selecione</option>
                <option *ngFor="let municipio of municipios" [value]="municipio.municipioId">{{municipio.nome.trim()}}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="txtLogradouro">Logradouro</label> *
              <input type="text" class="form-control" id="txtLogradouro"
                name="txtLogradouro" formControlName="txtLogradouro" placeholder="Logradouro">
              <small id="logradouroHelp" class="form-text text-muted">Digite pelo menos três caracteres.</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group text-right">
              <button type="button" class="btn btn-primary" (click)="onModalConsultarCEP()" [disabled]="!podeConsultar">Pesquisar</button>
              <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Cancelar</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group" style="height: 200px; overflow-y: auto;" *ngIf="enderecos?.length">
              <table class="table table-striped table-hover" aria-describedby="Listagem endereços">
                <thead>
                  <tr>
                    <th>Logradouro</th>
                    <th>Bairro</th>
                    <th>Munic&iacute;pio</th>
                    <th>UF</th>
                    <th>CEP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let endereco of enderecos">
                    <td>{{endereco.logradouro}}</td>
                    <td>{{endereco.bairro}}</td>
                    <td>{{endereco.cidade}}</td>
                    <td>{{endereco.estado}}</td>
                    <td><span class="linkCEP" (click)="onSelecionarCEP(endereco)"><u>{{cepFormatado(endereco.cep)}}</u></span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
      </div>

    </form>
  `,
  styles: [`
    span.linkCEP {
      color: #000000;
    }
    span.linkCEP:hover {
      cursor: pointer;
    }
  `]
})
export class NgbdModalContent implements OnInit, OnDestroy {

  public _titulo: string;
  public _enderecos: EnderecoModel[];
  public _ufs: UnidadeFederacaoModel[];
  public _municipios: MunicipioModel[];
  public _dadosConsultarLogradouro: FormGroup;
  public _enderecoFiltro: EnderecoModel = new EnderecoModel();
  public _podeConsultar = false;

  public _subscriptionDadosConsultarLogradouro: Subscription;

  public _enderecoModelSelecionado: Subject<EnderecoModel> = new Subject<EnderecoModel>();

  constructor(public readonly activeModal: NgbActiveModal,
    private readonly enderecoService: EnderecoService,
    private readonly municipioService: MunicipioService) { }

  public ngOnInit(): void {

    this.titulo = 'Consultar CEP';

    this.dadosConsultarLogradouro = new FormGroup({
      'ddlUF': new FormControl(''),
      'ddlMunicipio': new FormControl(''),
      'txtLogradouro': new FormControl()
    });

    this._subscriptionDadosConsultarLogradouro = this.dadosConsultarLogradouro.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  public cepFormatado(cep: number): string {
    const c: string = cep.toString();
    return c[0] + c[1] + '.' + c[2] + c[3] + c[4] + '-' + c[5] + c[6] + c[7];
  }

  public ngOnDestroy(): void {
    this._subscriptionDadosConsultarLogradouro.unsubscribe();
  }

  public get titulo(): string {
    return this._titulo;
  }

  public set titulo(v: string) {
    this._titulo = v;
  }

  public get enderecos(): EnderecoModel[] {
    return this._enderecos;
  }

  public set enderecos(v: EnderecoModel[]) {
    this._enderecos = v;
  }

  public get ufs(): string[] {
    return ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
      'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
      'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
  }

  public get municipios(): MunicipioModel[] {
    return this._municipios;
  }

  public get enderecoModelSelecionado(): Subject<EnderecoModel> {
    return this._enderecoModelSelecionado;
  }

  public get dadosConsultarLogradouro(): FormGroup {
    return this._dadosConsultarLogradouro;
  }

  public set dadosConsultarLogradouro(v: FormGroup) {
    this._dadosConsultarLogradouro = v;
  }

  public get podeConsultar(): boolean {
    return this._podeConsultar;
  }

  onValueChanged(data?: any) {
    this._podeConsultar =
      this._dadosConsultarLogradouro.value['ddlUF'] &&
      this._dadosConsultarLogradouro.value['ddlMunicipio'] &&
      this._dadosConsultarLogradouro.value['txtLogradouro'] &&
      this._dadosConsultarLogradouro.value['txtLogradouro'].length >= 3;
  }

  public onModalConsultarCEP(): void {

    const filtroPorLogradouro = new FiltroEnderecoPorLogradouroModel();
    filtroPorLogradouro.uf = this._dadosConsultarLogradouro.value['ddlUF'];
    filtroPorLogradouro.cidade = this._dadosConsultarLogradouro.value['ddlMunicipio'];
    filtroPorLogradouro.logradouro = this._dadosConsultarLogradouro.value['txtLogradouro'];

    this._enderecos = [];

    const s: Subscription = this.enderecoService
      .getEnderecoPeloLogradouro(filtroPorLogradouro)
      .subscribe((data: EnderecoModel[]) => {
        s.unsubscribe();
        this._enderecos = data;
      });
  }

  public onSelecionarCEP(end: EnderecoModel): void {
    this._enderecoModelSelecionado.next(end);
    this.activeModal.close('Close click');
  }

  public onSelecionarUF(uf: string): void {
    this._municipios = [];

    if (uf === '' || uf === undefined || uf === null) {
      return;
    }

    const s: Subscription = this.municipioService.getMunicipiosPorUF(uf)
      .subscribe((municipios: MunicipioModel[]) => {
        s.unsubscribe();
        this._municipios = municipios;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/ngbd-modal-content.ts